import gql from "graphql-tag";
import { GroupEntity, IGroupEntityAttributes } from "Models/Entities";
import { store } from "Models/Store";
import { GqlListResult } from "./shared";

// Developer note: Pagination and sorting not applied yet
export type GroupEntityQueryOptions = {
	filterByOrgId?: string;
}

export type GqlGroupEntityList = GqlListResult<{
	groupEntitys: IGroupEntityAttributes[]
}>;

export async function getGroups(queryOptions?: GroupEntityQueryOptions) {
	const groupsResult = await store.apolloClient.query<GqlGroupEntityList>({
		query: gql`
								query fetchGroupEntities {
									groupEntitys (
										where: [
										{
											path: "organisationId"
											comparison: equal,
											value: ["${queryOptions?.filterByOrgId}"],
										}],
										orderBy: [{path: "name", descending: false}],
									) {
										${GroupEntity.getAllAttributes().join('\n')}
									}
								}
							`,
		fetchPolicy: 'no-cache',
	});

	return groupsResult;
}